/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ subject: NonNullable<unknown> }} Rights_Edit_Subject_LabelInputs */



/**
* | output |
* | --- |
* | "Edit all rights for {subject}" |
*
* @param {Rights_Edit_Subject_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_edit_subject_label = /** @type {((inputs: Rights_Edit_Subject_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Edit_Subject_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle Rechte für ${i?.subject} bearbeiten`)
	return /** @type {LocalizedString} */ (`Edit all rights for ${i?.subject}`)
});